import { Component, OnInit } from '@angular/core';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { mapInfoView } from 'src/app/helper/interface/form-interface';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { ResponseData } from 'src/app/helper/interface/response';
import { ModalService } from 'src/app/shared/service/modal.service';
import { ChurchApiService } from '../../service/church-api.service';

@Component({
  selector: 'app-church-basic',
  templateUrl: './church-basic.component.html',
  styleUrls: ['./church-basic.component.scss']
})
export class ChurchBasicComponent implements OnInit {
  church_id: any;
  loading: boolean = false
  churchData: any = {}
  isModal: boolean = false;
  pageInfo: pageInfo = {} as pageInfo;
  showData: mapInfoView[] = [];
  constructor(private churchApi: ChurchApiService,
    private modalService: ModalService) { }

  ngOnInit(): void {
    this.pageInfo = {
      title: 'Church Info',
      buttonShowBtn: false,
    }
    this.showData = [{ name: 'church_name' }, { name: 'church_id' }, { name: 'zoneName' }, { name: 'fieldName' },
    { title: 'Est Date', name: 'established', type: 'DATE' }, { name: 'near_gems_church', title: 'Near Gems' }, { name: 'staff_emp_id', title: 'Staff Id' }, { name: 'staffName' },
    { name: 'updated_at', title: 'Last Updated At', type: "DATE" }]

  }

  setInput(data: any) {
    this.isModal = true;
    if (data.church_id) {
      this.church_id = data.church_id;
      this.getChurchData(this.church_id)
    }
  }

  getChurchData(id: any) {
    this.loading = true;
    this.churchApi.getBasic(id).then((res: ResponseData | any) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.churchData = res.result || {};
      }
    }).finally(() => this.loading = false)
  }

  close() {
    if (this.isModal)
      this.modalService.close();
  }
}
